export const colorsConfig = {
  mediumGrey: "rgb(51,65,85)",
  wabmBlue: "#3390FF",
};
